var React = require('react');

function CloseIcon (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".a{fill:#f0f0f0;}.b{fill:none;stroke:#a6a7a8;}")),React.createElement("title",{"key":1},"close-icon"),React.createElement("circle",{"className":"a","cx":"14.5","cy":"14.5","r":"14.5","key":2}),React.createElement("path",{"className":"b","d":"M9.67212,9.591l9.42078,9.42079","key":3}),React.createElement("path",{"className":"b","d":"M19.09312,9.591,9.67234,19.01179","key":4})]);
}

CloseIcon.defaultProps = {"viewBox":"0 0 29 29"};

module.exports = CloseIcon;

CloseIcon.default = CloseIcon;
